import { PanelType, SelectionMode } from "@fluentui/react";
import { Guid } from "@ioip/core/lib";
import CControl from "./CControl";
import CDataTable from "./CDataTable";
import { IFieldSchema } from "./IFieldSchema";
import { JSDataSource } from "./JSDataSource";
import { CForm } from "./JSForm";
import { IProjectForm } from "./IProjectForm";

export interface IJSGroupedDataGridProps {
    form: CForm;
    schema: IFieldSchema;
}

class JSGroupedDataGrid extends CControl {

    private $props: IJSGroupedDataGridProps;
    private $datasource: JSDataSource;
    private $formId: Guid = null;

    constructor(props: IJSGroupedDataGridProps) {
        super({ form: props.form, schema: props.schema, });
        this.$props = props;
        this.$formId = Guid.parse(this.$props.schema.formId);
    }

    get label(): string {
        return this.$props.schema.label;
    }

    get maxLength(): number {
        return this.$props.schema.maxLength;
    }

    get minLength(): number {
        return this.$props.schema.minLength;
    }

    get placeholder(): string {
        return this.$props.schema.placeholder;
    }

    get multiline(): boolean {
        return this.$props.schema.multiline;
    }

    get title(): string {
        return this.$props.schema.title;
    }

    get panelType(): PanelType {
        return this.$props.schema.panelType;
    }

    get selectionMode(): SelectionMode {
        return this.$props.schema.selectionMode || SelectionMode.none;
    }

    get panelTitle(): string {
        return this.$props.schema.panelTitle;
    }

    get formId(): Guid | null {
        return this.$formId;
    }

    get datasource(): JSDataSource {
        return this.$datasource;
    }

    /**
     * Obtiene el formulario asociado al control DataTable
     * @returns
     * @memberof JSGroupedDataGrid
     * @throws FormNotFoundException
     */
    getForm(): CForm {
        if (this.formId == null)
            return null;
        const form = this.$props.form.page.getForm(this.formId, null, {});
        return form;
    }

    getColumns(): IProjectForm[] {

        const columns: IProjectForm[] = [];

        let currentForm = this.getForm();
        while (currentForm != null) {

            columns.push({
                form: currentForm,
                order: columns.length
            })

            const datatable = currentForm.fields.cast<CDataTable>().firstOrDefault(f => f instanceof CDataTable);
            if (datatable != null) {

                currentForm = datatable.getForm();

            } else {

                currentForm = null;

            }

        }

        return columns;

    }

}

export default JSGroupedDataGrid;